/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import {
  Container,
  Grid,
  SvgIcon,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { globalColors } from "../../../../../../../_metronic/_assets/sass/custom/globalColors";
import { ReactComponent as editIcon } from "../../../../../../assets/icons/pencil-alt.svg";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../../../partials/datatable/styles";
import { AppAPIService } from "../../../../../../services/AppAPIService";

import { ReactComponent as trashIcon } from "../../../../../../assets/custom-icons/trash.svg";

import { debounce } from "lodash";
import { Col, Form } from "react-bootstrap";
import { RiSearchLine } from "react-icons/ri";
import InputForm from "../../../../../../components/InputForm";
import { ConfirmModal } from "./components/ConfirmModal";
import styles from "./styles.module.scss";
import { Pagination } from "@mui/material";

export const AutomaticResponseListing = (props) => {
  let api = AppAPIService.getInstance();
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [confirmedDelete, setConfirmedDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [lastPage, setLastPage] = useState(0)
  const history = useHistory();

  const tableHeaders = ["Ações", "Título", "Mensagem", "Data de Modificação"];

  const [automaticMessagesList, setAutomaticMessagesList] = useState([]);
  const [filterTitle, setFilterTitle] = useState("");

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleGetAutomatic = useCallback(
    async (page, rowsPerPage) => {
      try {
        setLoading(true);
        const response = await api.makeHttpRequest({
          url: `/automatic-message/list-paginated`,
          method: "GET",
          params: {
            page: page || 1,
            perPage: rowsPerPage || 1000,
            search: filterTitle,
          },
        });
        setAutomaticMessagesList(response.data);
        setLastPage(response?.meta?.lastPage)
      } catch (e) {
        Swal.fire("Erro!", "Erro ao buscar respostas automáticas.", "error");
      }
      setLoading(false);
    },
    [api, filterTitle]
  );

  const handleFilterTitle = useCallback(
    debounce((value) => {
      setFilterTitle(value);
    }, 500),
    []
  );

  useEffect(() => {
    handleGetAutomatic(page, itemsPerPage);
  }, [handleGetAutomatic, page, itemsPerPage]);

  const [idToDelete, setIdToDelete] = useState(null);

  const handleConfirmDelete = useCallback(
    async (id) => {
      try {
        const result = await api.makeHttpRequest({
          method: "DELETE",
          url: `/automatic-message/${id}`,
        });

        if (result?.status == 404) {
          Swal.fire(
            "Erro!",
            "Erro ao deletar parametrização de documento, mensagem não encontrada.",
            "error"
          );
          return;
        }

        setLoading(false);
        Swal.fire(
          "Sucesso!",
          "Parametrização de documento deletada com sucesso.",
          "success"
        ).then(() => {
          history.push("/admin/parametrizacao");
        });
      } catch (e) {
        Swal.fire(
          "Erro!",
          "Erro ao deletar parametrização de documento.",
          "error"
        );
      }
      setConfirmedDelete(false);
      setLoading(false);
    },
    [api, history]
  );

  const handleDeleteRecord = (id) => {
    setIdToDelete(id);
    setShowConfirmDeleteModal(true);
  };

  useEffect(() => {
    if (confirmedDelete) {
      handleConfirmDelete(idToDelete);
    }
  }, [confirmedDelete, handleConfirmDelete, idToDelete]);

  return (
    <Container
      style={{
        boxShadow: "none",
        padding: 0,
        margin: 0,
      }}
      maxWidth="xl"
    >
      <ConfirmModal
        open={showConfirmDeleteModal}
        handleOpen={setShowConfirmDeleteModal}
        handleConfirm={handleConfirmDelete}
        setConfirmedDelete={setConfirmedDelete}
        id={idToDelete}
        setId={setIdToDelete}
      />
      <Grid
        xl={12}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        container
        style={{
          padding: 0,
        }}
      >
        <Grid
          xs={12}
          style={{
            paddingRight: "5px",
            marginTop: "10px",
          }}
        >
          <Form.Group
            as={Col}
            xs="12"
            className={
              "rmv-all-props row-group-padding row-group-margin-bottom row-grop-margin-bottom-mobile icon-search"
            }
            style={{
              marginTop: "0",
            }}
          >
            <button type="button">
              <RiSearchLine size={20} />
            </button>
            <Form.Control
              type="text"
              name="search"
              style={{
                paddingLeft: "60px",
                border: `0.5px solid ${globalColors.backgroundColor2}`,
              }}
              className={styles.searchInput}
              onChange={(e) => handleFilterTitle(e.target.value)}
              onFocus={(e) =>
                (e.target.style.border = `.5px solid ${globalColors.primaryColor1}`)
              }
              onBlur={(e) =>
                (e.target.style.border = `.5px solid ${globalColors.textColor2}70`)
              }
              size="lg"
              placeholder="Busque pelo título"
            />
          </Form.Group>
        </Grid>
        <Container
          maxWidth="xl"
          style={{
            boxShadow: "none",
            border: "1px solid #e0e0e0",
            borderRadius: "5px",
            padding: 0,
            textAlign: "left",
            marginTop: "20px",
          }}
        >
          <Table
            className="table"
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              padding: "0px",
              borderCollapse: "collapse",
              borderSpacing: "0px",
              width: "100%",
            }}
          >
            <TableHead>
              <TableRow
                style={{
                  textAlign: "left",
                  backgroundColor: globalColors.secondaryColor3,
                }}
              >
                {tableHeaders.map((header, index) => (
                  <StyledTableCell
                    key={index}
                    style={{
                      textAlign:
                        header === "Ações" || header === "Data de Modificação"
                          ? "center"
                          : "left",
                      backgroundColor: globalColors.secondaryColor3,
                    }}
                  >
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              style={{
                textAlign: "left",
              }}
            >
              {automaticMessagesList.map((row) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell
                    style={{
                      width: "100px",
                      textAlign: "center",
                      padding: "4px 20px",
                    }}
                  >
                    <Container
                      maxWidth="xl"
                      style={{
                        padding: "0px 10px",
                        minWidth: "70px",
                        width: "60px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <SvgIcon
                        onClick={() => {
                          props.setEditingRecord(row);
                        }}
                        style={{
                          width: "20px",
                          height: "20px",
                          color: globalColors.backgroundColor2,
                          fill: "transparent",
                          cursor: "pointer",
                        }}
                        component={editIcon}
                      />
                      <SvgIcon
                        onClick={() => {
                          handleDeleteRecord(row.id);
                        }}
                        style={{
                          width: "20px",
                          height: "20px",
                          color: globalColors.backgroundColor2,
                          fill: "transparent",
                          cursor: "pointer",
                        }}
                        component={trashIcon}
                      />
                    </Container>
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "100px",
                      textAlign: "left",
                    }}
                  >
                    {row.title}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      textAlign: "left",
                    }}
                  >
                    {row.message}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {new Date(row.updatedAt)
                      .toLocaleString("pt-BR")
                      .replace(",", " - ")}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
          <div style={{
            display: "flex",
            justifyContent: "flex-end"
          }}>
            <Pagination count={lastPage} page={page} onChange={handlePageChange} />
          </div>
        </Container>
      </Grid>
    </Container>
  );
};
